import _classCallCheck from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src4243671113/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command } from 'ckeditor5/src/core.js';
import { normalizeColumnWidths } from './utils.js';
/**
 * Command used by the {@link module:table/tablecolumnresize~TableColumnResize Table column resize feature} that
 * updates the width of the whole table as well as its individual columns.
 */
var TableWidthsCommand = /*#__PURE__*/function (_Command) {
  _inherits(TableWidthsCommand, _Command);
  var _super = _createSuper(TableWidthsCommand);
  function TableWidthsCommand() {
    _classCallCheck(this, TableWidthsCommand);
    return _super.apply(this, arguments);
  }
  _createClass(TableWidthsCommand, [{
    key: "refresh",
    value:
    /**
     * @inheritDoc
     */
    function refresh() {
      // The command is always enabled as it doesn't care about the actual selection - table can be resized
      // even if the selection is elsewhere.
      this.isEnabled = true;
    }
    /**
     * Updated the `tableWidth` attribute of the table and the `columnWidth` attribute of the columns of that table.
     */
  }, {
    key: "execute",
    value: function execute() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _this$editor = this.editor,
        model = _this$editor.model,
        plugins = _this$editor.plugins;
      var _options$table = options.table,
        table = _options$table === void 0 ? model.document.selection.getSelectedElement() : _options$table,
        columnWidths = options.columnWidths,
        tableWidth = options.tableWidth;
      if (columnWidths) {
        // For backwards compatibility, columnWidths might be an array or a string of comma-separated values.
        columnWidths = Array.isArray(columnWidths) ? columnWidths : columnWidths.split(',');
      }
      model.change(function (writer) {
        if (tableWidth) {
          writer.setAttribute('tableWidth', tableWidth, table);
        } else {
          writer.removeAttribute('tableWidth', table);
        }
        var tableColumnGroup = plugins.get('TableColumnResizeEditing').getColumnGroupElement(table);
        if (!columnWidths && !tableColumnGroup) {
          return;
        }
        if (!columnWidths) {
          return writer.remove(tableColumnGroup);
        }
        var widths = normalizeColumnWidths(columnWidths);
        if (!tableColumnGroup) {
          var colGroupElement = writer.createElement('tableColumnGroup');
          widths.forEach(function (columnWidth) {
            return writer.appendElement('tableColumn', {
              columnWidth: columnWidth
            }, colGroupElement);
          });
          writer.append(colGroupElement, table);
        } else {
          Array.from(tableColumnGroup.getChildren()).forEach(function (column, index) {
            return writer.setAttribute('columnWidth', widths[index], column);
          });
        }
      });
    }
  }]);
  return TableWidthsCommand;
}(Command);
export { TableWidthsCommand as default };